import { Button, Checkbox, FormControlLabel } from "@mui/material";
import styles from "./assignpermission.module.css";
import axios from 'axios';
import { useAuth0 } from "@auth0/auth0-react";
import { useEffect } from "react";
import { useState } from "react";
import { TableLoaderSmall } from "../../../components/LoaderC";
import { Search } from "react-feather";

const ModuleNameTag = ({ name }) => {
    return <p style={{ textTransform: 'capitalize' }} className={`${styles.PermissionMainTItle}`}>{name}</p>
}

const SubModuleNameTag = ({ name }) => {
    return <p style={{ textTransform: 'capitalize' }} className={`${styles.PermissionSubTItle}`}>{name}</p>
}

const ParentPermissionChkTag = ({ module, allPermissions, onCngBulkPerms, isChecked, isIndeterminate }) => {
    return <FormControlLabel
        className="PermissionMainCHeck"
        control={<Checkbox
            indeterminate={!isChecked && isIndeterminate}
            checked={isChecked}
            onChange={(e) => {
                let perms = [];
                let selMods = allPermissions?.filter(i => i?.module === module);

                if (selMods.length > 0) {
                    let selMod = selMods[0];
                    selMod?.permissions?.forEach(i => {
                        perms.push(module + ':' + i);
                    });
                    if (selMod?.children?.length > 0) {
                        selMod?.children?.forEach(i => {
                            i?.permissions?.forEach(j => {
                                perms.push(module + '-' + i?.module + ':' + j);
                            });
                        });
                    }
                } else if (module === 'Security') {
                    allPermissions?.forEach((i) => {
                        i?.children?.forEach((j) => {
                            if (j?.module === 'vehicle' || j?.module === 'journal') {
                                j?.permissions?.forEach(k => {
                                    perms.push(j?.module + ':' + k);
                                });
                            }
                        });
                    });
                } else if (module === 'Schedule') {
                    allPermissions?.forEach((i) => {
                        i?.children?.forEach((j) => {
                            if (j?.module === 'openhouse' || j?.module === 'event') {
                                j?.permissions?.forEach(k => {
                                    perms.push(j?.module + ':' + k);
                                });
                            }
                        });
                    });
                }

                onCngBulkPerms(e, perms);
            }}
        />}
        label="All Permissions"
    />
}

const PermissionChkTag = ({ moduleName, subModuleName, permission, permissionList, onCngPerms, permissionTitle, isChecked }) => {
    //let permVal = subModuleName !== '' ? moduleName + '-' + subModuleName + ':' + permission : moduleName + ':' + permission;

    let permVal = '';
    if (moduleName !== '' && subModuleName !== '') {
        permVal = moduleName + '-' + subModuleName;
    } else if (moduleName === '') {
        permVal = subModuleName;
    } else if (subModuleName === '') {
        permVal = moduleName;
    }
    permVal = permVal + ':' + permission;

    if (permVal === 'task-checklist:read') {
        return null;
    }

    return <FormControlLabel
        className="PermissionMainCHeck"
        control={<Checkbox
            value={permVal}
            checked={isChecked}
            onChange={(e) => onCngPerms(e)}
        />}
        label={permissionTitle}
    />
}

const AssignPermission = ({ setAssignModalOpen, allPermissions, roleData, assignPremission }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [allPermissionList, setAllPermissionList] = useState([]);
    const [permissionList, setPermissionList] = useState([]);
    const [newPermissionList, setNewPermissionList] = useState([]);
    const [searchKey, setSearchKey] = useState('');

    useEffect(() => {
        async function getPermission() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/roles/" + roleData?.id + "/permissions", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPermissionList(response.data.data?.map(i => {
                    return i?.permission_name;
                }));
                setNewPermissionList(response.data.data?.map(i => {
                    return i?.permission_name;
                }));
                setContentLoading(false);
            }).catch((error) => {
                setContentLoading(false);
            });
        }

        if (roleData)
            getPermission();
        else
            setContentLoading(false);
    }, [roleData, getAccessTokenSilently]);

    const onCngBulkPerms = (e, perms) => {
        if (e.target.checked) {
            setNewPermissionList(prev => {
                perms?.forEach(i => {
                    if (prev?.indexOf(i) === -1) {
                        prev = prev.concat(i);
                    }
                })
                return prev;
            });
        } else {
            setNewPermissionList(prev => {
                perms?.forEach(i => {
                    prev = prev?.filter(j => i !== j);
                })
                return prev;
            });
        }
    }

    const onCngPerms = (parentModule, e) => {
        let newPVal = e.target.value;

        if (parentModule === 'notification') {
            if (e.target.checked) {
                setNewPermissionList(prev => {
                    if (prev?.indexOf(newPVal) === -1) {
                        return prev.concat([newPVal]);
                    }
                    return prev;
                });
            } else {
                setNewPermissionList(prev => {
                    return prev?.filter(i => i !== newPVal);
                });
            }
        } else if (newPVal === 'task-checklist:update') {
            if (e.target.checked) {
                setNewPermissionList(prev => {
                    if (prev?.indexOf(newPVal) === -1) {
                        return prev.concat(['task-checklist:update', 'task-checklist:read']);
                    }
                    return prev;
                });
            } else {
                setNewPermissionList(prev => {
                    return prev?.filter(i => i !== 'task-checklist:update' && i !== 'task-checklist:read');
                });
            }
        } else {
            if (e.target.checked) {
                setNewPermissionList(prev => {
                    if (prev?.indexOf(newPVal) === -1) {
                        return prev.concat(newPVal);
                    }
                    return prev;
                });

                if (parentModule !== '' && newPVal !== parentModule + ':read') {
                    setNewPermissionList(prev => {
                        if (prev?.indexOf(parentModule + ':read') === -1) {
                            return prev.concat(parentModule + ':read');
                        }
                        return prev;
                    });
                }
            } else {
                setNewPermissionList(prev => {
                    return prev?.filter(i => i !== newPVal);
                });
            }
        }
    }

    const addPremission = () => {
        assignPremission(newPermissionList);
    }

    const isPermsExits = (permName) => {
        if (permName === 'lease-sign:read') {
            permName = 'lease-sign:create';
        }

        if (permName === 'notification-dailyreportmail:read') {
            permName = 'notification-dailyreportmail:create';
        }

        if (permName === 'notification-followupmessage:read') {
            permName = 'notification-followupmessage:create';
        }

        if (newPermissionList.indexOf(permName) > -1) {
            return true;
        }
        return false;
    }

    const isPermsExitsAll = (module) => {
        let perms = [];
        let selMods = allPermissions?.filter(i => i?.module === module);

        if (selMods.length > 0) {
            let selMod = selMods[0];
            selMod?.permissions?.forEach(i => {
                perms.push(module + ':' + i);
            });
            if (selMod?.children?.length > 0) {
                selMod?.children?.forEach(i => {
                    i?.permissions?.forEach(j => {
                        perms.push(module + '-' + i?.module + ':' + j);
                    });
                });
            }
        } else if (module === 'Security') {
            allPermissions?.forEach((i) => {
                i?.children?.forEach((j) => {
                    if (j?.module === 'vehicle' || j?.module === 'journal') {
                        j?.permissions?.forEach(k => {
                            perms.push(j?.module + ':' + k);
                        });
                    }
                });
            });
        } else if (module === 'Schedule') {
            allPermissions?.forEach((i) => {
                i?.children?.forEach((j) => {
                    if (j?.module === 'openhouse' || j?.module === 'event') {
                        j?.permissions?.forEach(k => {
                            perms.push(j?.module + ':' + k);
                        });
                    }
                });
            });
        }

        let isAllCheked = false;

        if (perms.length > 0) {
            isAllCheked = true;
            perms?.forEach(i => {
                if (newPermissionList?.indexOf(i) === -1)
                    isAllCheked = false;
            })
        }

        return isAllCheked;
    }

    const isPermsExitsOne = (module) => {
        let perms = [];
        let selMods = allPermissions?.filter(i => i?.module === module);

        if (selMods.length > 0) {
            let selMod = selMods[0];
            selMod?.permissions?.forEach(i => {
                perms.push(module + ':' + i);
            });
            if (selMod?.children?.length > 0) {
                selMod?.children?.forEach(i => {
                    i?.permissions?.forEach(j => {
                        perms.push(module + '-' + i?.module + ':' + j);
                    });
                });
            }
        } else if (module === 'Security') {
            allPermissions?.forEach((i) => {
                i?.children?.forEach((j) => {
                    if (j?.module === 'vehicle' || j?.module === 'journal') {
                        j?.permissions?.forEach(k => {
                            perms.push(j?.module + ':' + k);
                        });
                    }
                });
            });
        } else if (module === 'Schedule') {
            allPermissions?.forEach((i) => {
                i?.children?.forEach((j) => {
                    if (j?.module === 'openhouse' || j?.module === 'event') {
                        j?.permissions?.forEach(k => {
                            perms.push(j?.module + ':' + k);
                        });
                    }
                });
            });
        }

        let isAllCheked = false;

        if (perms.length > 0) {
            perms?.forEach(i => {
                if (newPermissionList?.indexOf(i) > -1)
                    isAllCheked = true;
            })
        }

        return isAllCheked;
    }

    const searchMenu = (items, searchText) => {
        return items.map(item => {
            const parentMatch = item?.title?.toLowerCase().includes(searchText.toLowerCase());

            const matchedChildren = item.children?.filter(child =>
                child?.title?.toLowerCase().includes(searchText.toLowerCase())
            );

            if (parentMatch) {
                return item;
            }

            if (matchedChildren?.length > 0) {
                return { ...item, children: matchedChildren || [] };
            }

            return null;
        }).filter(Boolean);
    }

    useEffect(() => {
        if (searchKey !== '') {
            let allPermissionsTemp = allPermissions;
            allPermissionsTemp = searchMenu(allPermissionsTemp, searchKey);

            setAllPermissionList(allPermissionsTemp);
        } else {
            setAllPermissionList(allPermissions);
        }
    }, [searchKey, allPermissions]);

    return (<div>
        {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

        {!contentLoading && <>
            <div className={`${styles.RoleMainSec}`}>
                <div className={`${styles.SearchConPop}`}>
                    <div className={`${styles.SearchConSec}`}>
                        <Search />
                        <input type="text" placeholder="Search" onChange={(e) => setSearchKey(e.target.value)} />
                    </div>
                </div>
                <div className={`${styles.AssignTableSec}`}>
                    {allPermissionList?.map(item => {
                        return <table className={`${styles.PermissionMainTable}`}>
                            <tr>
                                <td>
                                    <ModuleNameTag name={item?.title} />
                                </td>
                                <td>
                                    <ParentPermissionChkTag module={item?.module !== '' ? item?.module : item?.title} allPermissions={allPermissions} onCngBulkPerms={onCngBulkPerms.bind(this)} isChecked={isPermsExitsAll(item?.module !== '' ? item?.module : item?.title)} isIndeterminate={isPermsExitsOne(item?.module !== '' ? item?.module : item?.title)} />
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={5} className={`${styles.NoPaddNoBorder}`}>
                                    <table className={`${styles.PermissionSubTable}`}>
                                        {item?.permissions?.length > 0 && <tr>
                                            <td>
                                                <SubModuleNameTag name={item?.subTitle} />
                                                {(item?.module === 'dashboard' || item?.module === 'request' || item?.module === 'smschat') && <p className={styles.ScopeInfo}>
                                                    Used in: Web App + Management App
                                                </p>}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('read') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'read'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Read Only"} isChecked={isPermsExits(item?.module + ':read')} />}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('create') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'create'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Create"} isChecked={isPermsExits(item?.module + ':create')} />}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('update') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'update'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Update"} isChecked={isPermsExits(item?.module + ':update')} />}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('delete') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'delete'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Delete"} isChecked={isPermsExits(item?.module + ':delete')} />}
                                            </td>
                                        </tr>}
                                        {item?.children?.length > 0 && item?.children?.map(subitem => {
                                            return (<tr>
                                                <td>
                                                    <SubModuleNameTag name={subitem?.title} />
                                                    {(subitem?.module === 'device' || subitem?.module === 'schedule' || subitem?.module === 'resolve' || subitem?.module === 'vehicle' || subitem?.module === 'journal' || subitem?.module === 'checklist') && <p className={styles.ScopeInfo}>
                                                        Used in: Web App + Management App
                                                    </p>}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('read') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'read'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Read Only"} isChecked={isPermsExits(item?.module !== '' ? item?.module + '-' + subitem?.module + ':read' : subitem?.module + ':read')} />}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('create') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'create'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Create"} isChecked={isPermsExits(item?.module !== '' ? item?.module + '-' + subitem?.module + ':create' : subitem?.module + ':read')} />}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('update') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'update'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Update"} isChecked={isPermsExits(item?.module !== '' ? item?.module + '-' + subitem?.module + ':update' : subitem?.module + ':read')} />}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('delete') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'delete'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this, item?.module)} permissionTitle={"Delete"} isChecked={isPermsExits(item?.module !== '' ? item?.module + '-' + subitem?.module + ':delete' : subitem?.module + ':read')} />}
                                                </td>
                                            </tr>)
                                        })}
                                    </table>
                                </td>
                            </tr>
                        </table>
                    })}
                    {/*allPermissionList?.map(item => {
                        return <table className={`${styles.PermissionMainTable}`}>
                            <tr>
                                <td>
                                    <ModuleNameTag name={item?.module} />
                                </td>
                                <td>
                                    <ParentPermissionChkTag module={item?.module} allPermissions={allPermissions} onCngBulkPerms={onCngBulkPerms.bind(this)} isChecked={isPermsExitsAll(item?.module)} isIndeterminate={isPermsExitsOne(item?.module)} />
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colSpan={5} className={`${styles.NoPaddNoBorder}`}>
                                    <table className={`${styles.PermissionSubTable}`}>
                                        <tr>
                                            <td>
                                                <SubModuleNameTag name={item?.module} />
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('read') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'read'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Read Only"} isChecked={isPermsExits(item?.module + ':read')} />}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('create') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'create'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Create"} isChecked={isPermsExits(item?.module + ':create')} />}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('update') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'update'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Update"} isChecked={isPermsExits(item?.module + ':update')} />}
                                            </td>
                                            <td>
                                                {item?.permissions.indexOf('delete') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName="" permission={'delete'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Delete"} isChecked={isPermsExits(item?.module + ':delete')} />}
                                            </td>
                                        </tr>
                                        {item?.children?.length > 0 && item?.children?.map(subitem => {
                                            return (<tr>
                                                <td>
                                                    <SubModuleNameTag name={subitem?.module} />
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('read') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'read'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Read Only"} isChecked={isPermsExits(item?.module + '-' + subitem?.module + ':read')} />}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('create') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'create'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Create"} isChecked={isPermsExits(item?.module + '-' + subitem?.module + ':create')} />}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('update') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'update'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Update"} isChecked={isPermsExits(item?.module + '-' + subitem?.module + ':update')} />}
                                                </td>
                                                <td>
                                                    {subitem?.permissions.indexOf('delete') > -1 && <PermissionChkTag moduleName={item?.module} subModuleName={subitem?.module} permission={'delete'} permissionList={permissionList} onCngPerms={onCngPerms.bind(this)} permissionTitle={"Delete"} isChecked={isPermsExits(item?.module + '-' + subitem?.module + ':delete')} />}
                                                </td>
                                            </tr>)
                                        })}
                                    </table>
                                </td>
                            </tr>
                        </table>
                    })*/}
                </div>
            </div>
            <div className={`${styles.ButtonAction}`}>
                <Button onClick={(e) => setAssignModalOpen(false)} className="CancelPopupBU">Cancel</Button>
                <Button className="SubmitPopupBU" onClick={(e) => addPremission()} type="button">{roleData ? 'Update' : 'Add'}</Button>
            </div>
        </>}
    </div>)
}

export default AssignPermission;
